'use client';

import Hero from '@/components/VGFS/Hero';
import ChattelMortgageContent from '@/components/ChattelMortgageContent';

// Client component for interactive content
export default function ChattelMortgagePage() {
  return (
    <>
      {/* High-performance optimized hero section */}
      <Hero />
      
      {/* Remaining page content */}
      <ChattelMortgageContent />
    </>
  );
}